module.exports = __webpack_public_path__ + "static/media/zhijitiaozhengtiaojiantu.7b491f0e.png";